"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR = exports.EHR_MYCHART = void 0;
exports.EHR_MYCHART = 'mychart';
// Error types
exports.ERROR = {
    ERROR_EHR_LOGIN: 'ERROR_EHR_LOGIN',
    ERROR_EHR_INVALID_PID: 'ERROR_EHR_INVALID_PID',
    ERROR_EHR_INVALID_ACCESS_TOKEN: 'ERROR_EHR_INVALID_ACCESS_TOKEN',
    ERROR_EHR_INVALID_SOURCE_SYSTEM: 'ERROR_EHR_INVALID_SOURCE_SYSTEM',
    ERROR_EHR_NOT_AUTHORIZED_BY_USER: 'ERROR_EHR_NOT_AUTHORIZED_BY_USER' // user rejects sharing information from EHR
};
//# sourceMappingURL=thirdPartyLogin.js.map